import React from 'react';
import styled from '@emotion/styled';
import colours from '~/utils/colours';
import { TemplateState } from '../Pages/Editor';

const states = {
  demo: {
    title: 'Customise your brand by creating a new Message Template',
    actionUrl: '/message-templates',
    actionText: 'Create new',
  },
  locked: {
    title: 'Upgrade your plan to brand your landing pages & emails',
    actionUrl:
      '/billing/checkout?ref=message-templates&redirect=message-templates',
    actionText: 'Upgrade',
  },
};

export const getHighlightForState = (state, isNextGen) => {
  switch (state) {
    case TemplateState.Demo:
    case TemplateState.Locked: {
      const props = states[state];
      if (isNextGen) {
        props.title =
          'Upgrade to use Next Gen templates - available on the Pro plan';
      }

      return <HighlightWarning {...props} />;
    }

    default:
      return null;
  }
};

const HighlightContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${colours.planlockOverlay};
  z-index: 1500;
`;

const HighlightBox = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  font-size: 17px;
  color: ${colours.greyDark};
  font-weight: bold;
  padding: 0 20px;
`;

const HighlightText = styled.div`
  display: inline-block;
  background: ${colours.planlockOverlay};
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
`;

interface HighlightWarningProps {
  title: string;
  actionText: string;
  actionUrl: string;
}

export default function HighlightWarning({
  title,
  actionText,
  actionUrl,
}: HighlightWarningProps) {
  return (
    <HighlightContainer>
      <HighlightBox>
        <HighlightText>
          <p>{title}</p>
          <a href={actionUrl} className='btn btn-primary'>
            {actionText}
          </a>
        </HighlightText>
      </HighlightBox>
    </HighlightContainer>
  );
}
